import moment from 'moment';

export const getEntityId = (value) => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value !== 'object') return value;
  return value.service_id
    ?? value.team_member_id
    ?? value.salon_id
    ?? value.appointment_id
    ?? value.id
    ?? value.pk
    ?? '';
};

export const createInitialProposalForm = (appointment) => {
  const start = appointment?.start_time || '';
  return {
    proposed_service: String(getEntityId(appointment?.service) || ''),
    proposed_team_member: String(getEntityId(appointment?.team_member) || ''),
    proposed_date: start ? moment.parseZone(start).format('YYYY-MM-DD') : '',
    proposed_start_time: start,
    expiry_hours: appointment?.salon_proposal_default_expiry_hours || 24,
    message: '',
  };
};

export const optionExists = (options, selectedId) => (
  !selectedId
  || (options || []).some((option) => String(getEntityId(option)) === String(selectedId))
);

const slotMinute = (value) => (
  value && moment.parseZone(value).isValid()
    ? moment.parseZone(value).format('YYYY-MM-DDTHH:mm')
    : ''
);

export const selectMatchingSlot = (slots, requested) => {
  const requestedMinute = slotMinute(requested);
  if (!requestedMinute) return '';
  return (slots || []).find((slot) => slotMinute(slot) === requestedMinute) || '';
};

export const buildProposalAvailabilityArgs = ({
  appointmentId,
  serviceId,
  teamMemberId,
  date,
}) => {
  if (!appointmentId || !serviceId || !teamMemberId || !date) return undefined;
  return {
    serviceId: Number(serviceId),
    teamMemberId: Number(teamMemberId),
    date,
    excludeAppointmentId: Number(appointmentId),
  };
};
